/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import {
  readIsLoggedIn,
  readStaffInfo,
  readIsLoggedInUser,
} from "@/store/main/getters";
import {
  dispatchAddVisitStat,
  dispatchCheckLoggedIn,
  dispatchWereportLogIn,
  dispatchGetMyLastProject,
  dispatchGetStaffInfo,
  dispatchLogIn,
  dispatchUpdateMyLastProject,
  dispatchWechatLogIn,
} from "@/store/main/actions";
import Home from "../views/Home.vue";
import Home1 from "../views/Home1.vue";
import { store } from "@/store";
import {
  getLocalProject,
  saveLocalProject,
  saveLocalStoragePreRoute,
  saveLocalStorageProject,
} from "@/utils";
import { envTag } from "@/env";
import axios from "axios";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import {
  dispatchGetProjectUsers,
  dispatchGetMyProjects,
} from "@/store/project/actions";
import { readProjectUsers, readMyProjects } from "@/store/project/getters";
import { TimePickPanel } from "element-plus/lib/el-time-picker";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/",
  //   name: "Home1",
  //   component: Home1,
  // },
  {
    path: "/performance",
    name: "Performance",
    component: () => import("../components/WorkBench/SideMenu.vue"), //路由懒加载，使用回调函数就能实现  提升首次加载性能！（首次只加载了一个组件，其他的是动态懒加载的）
    children: [
      // {
      //   path: "/project_overview",
      //   name: "ProjectOverview",
      //   component: () =>
      //     import(/* webpackChunkName: "performance chart" */ "../views/performance/ProjectOverview.vue"),
      // },

      {
        path: "/project_overview",
        name: "ProjectOverview",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/ProjectOverview.vue"
          ),
      },
      {
        path: "/test_report",
        name: "TestReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReport.vue"
          ),
      },
      {
        path: "/nzm_test_report",
        name: "NzmTestReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/NzmTestReport.vue"
          ),
      },
      {
        path: "/cfr_test_report",
        name: "CfrTestReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/CfrTestReport.vue"
          ),
      },
      {
        path: "/smoke_from_light_exposure",
        name: "SmokeFromLightExposure",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/SmokeFromLightExposure.vue"
          ),
      },
      {
        path: "/smoke_from_light_exposure_qq",
        name: "SmokeFromLightExposureQQ",
        component: () =>
          import("../views/performance/SmokeFromLightExposureQQ/index.vue"),
      },
      {
        path: "/smoke_from_light_exposure_role",
        name: "SmokeFromLightExposureRole",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/SmokeFromLightExposureRole.vue"
          ),
      },
      {
        path: "/use_case_monitoring",
        name: "UseCaseMonitoring",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/UseCaseMonitoring.vue"
          ),
      },
      {
        path: "/perfetto_memory",
        name: "PerfettoMemory",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/PerfettoMemory.vue"
          ),
      },
      {
        path: "/xcode_memory",
        name: "XcodeMemory",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/XcodeMemory/index.vue"
          ),
      },
      {
        path: "/ios-memory-auto",
        name: "ios-memory-auto",
        component: () =>
          import("../views/performance/ios-memory-auto/index.vue"),
      },
      {
        path: "/test_report_aov",
        name: "TestReportAOV",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportAOV.vue"
          ),
      },

      {
        path: "/test_report_aov2",
        name: "TestReportAOV2",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportAOV2.vue"
          ),
      },
      {
        path: "/test_report_top",
        name: "TestReportTOP",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportTOP.vue"
          ),
      },
      {
        path: "/test_report_skin",
        name: "TestReportSkin",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportSkin.vue"
          ),
      },
      {
        path: "/test_report_skin_data",
        name: "TestReportSkinData",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportSkinData.vue"
          ),
      },
      {
        path: "/test_report_skin_inside",
        name: "TestReportSkinInside",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportSkinInside.vue"
          ),
      },
      {
        path: "/test_statistics",
        name: "TestStatistics",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestStatistics.vue"
          ),
      },

      {
        path: "/test_report_skin_osgame",
        name: "TestReportSkinOsgame",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportSkinOsgame.vue"
          ),
      },
      {
        path: "/test_report_skin_smg",
        name: "TestReportSkinSmg",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportSkinSmg.vue"
          ),
      },
      {
        path: "/ui_test_report",
        name: "UiTestReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/UiTestReport.vue"
          ),
      },
      {
        path: "/ui_test_smg_report",
        name: "UiTestSmgReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/UiTestSmgReport.vue"
          ),
      },
      {
        path: "/label_scenario_report",
        name: "LabelScenarioReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/LabelScenarioReport.vue"
          ),
      },
      {
        path: "/label_scenario_diagram",
        name: "LabelSceneDiagram",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/LabelSceneDiagram.vue"
          ),
      },
      {
        path: "/dc_statistics",
        name: "DcStatistics",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DcStatistics.vue"
          ),
      },
      {
        path: "/test_report_speedmobile",
        name: "TestReportspeedmobile",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/TestReportspeedmobile.vue"
          ),
      },

      {
        path: "/gpu_counter2",
        name: "GpuCounter2",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/GpuCounter2.vue"
          ),
      },
      {
        path: "/gpu_counter",
        name: "GpuCounter",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/GpuCounter.vue"
          ),
      },
      {
        path: "/deep_performance_cpu_data",
        name: "DeepPerformanceCpuData",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceCpuData.vue"
          ),
      },
      {
        path: "/deep_performance_cpu_performance",
        name: "DeepPerformanceCpuPerformance",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceCpuPerformance.vue"
          ),
      },
      {
        path: "/deep_performance_thread_performance",
        name: "DeepPerformanceThreadPerformance",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceThreadPerformance.vue"
          ),
      },
      {
        path: "/deep_performance_total_functions",
        name: "DeepPerformanceTotalFunction",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceTotalFunction.vue"
          ),
      },
      {
        path: "/deep_performance_lag_analysis",
        name: "DeepPerformanceLagAnalysis",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceLagAnalysis.vue"
          ),
      },
      {
        path: "/deep_performance_gpu_performance",
        name: "DeepPerformanceGpuPerformance",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceGpuPerformance.vue"
          ),
      },
      {
        path: "/deep_performance_analysis",
        name: "DeepPerformanceAnalysis",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceAnalysis.vue"
          ),
      },
      {
        path: "/deep_performance_new_overview",
        name: "DeepPeformanceNewOverview",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPeformanceNewOverview.vue"
          ),
      },
      {
        path: "/deepPeformance_configuration",
        name: "DeepPeformanceConfiguration",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPeformanceConfiguration.vue"
          ),
      },
      {
        path: "/deep_performance_cpu_summary",
        name: "DeepPerformanceCpuSummary",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceCpuSummary.vue"
          ),
      },
      {
        path: "/deep_performance_cpu_data_upload",
        name: "DeepPerformanceCpuDataUpload",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceCpuDataUpload.vue"
          ),
      },
      {
        path: "/deep_performance_cpu_test_report",
        name: "DeepPerformanceCpuTestReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepPerformanceCpuTestReport.vue"
          ),
      },
      {
        path: "/deep_memory_performance",
        name: "DeepMemoryPerformance",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/DeepMemoryPerformance.vue"
          ),
      },
      {
        path: "/reactars",
        name: "Reactars",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/Reactars.vue"
          ),
      },
      {
        path: "/cfm_arms_report",
        name: "CfmArmsReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/CfmArmsReport.vue"
          ),
      },
      {
        path: "/cfm_pve_report",
        name: "CfmPveReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/CfmPveReport.vue"
          ),
      },
      {
        path: "/automated_cpu_functions",
        name: "AutomatedCpuFunctions",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/AutomatedCpuFunctions.vue"
          ),
      },
      {
        path: "/performance_chart",
        name: "PerformanceChart",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/PerformanceChart.vue"
          ),
      },
      {
        path: "/task",
        name: "Task",
        component: () =>
          import(/* webpackChunkName: "task" */ "../views/task/TaskList.vue"),
      },
      // {
      //   path: "/test",
      //   name: "Test",
      //   component: () =>
      //     import(/* webpackChunkName: "task" */ "../views/Test.vue"),
      // },
      {
        path: "/task-record",
        name: "TaskRecord",
        component: () =>
          import(/* webpackChunkName: "task" */ "../views/task/TaskRecord.vue"),
      },
      {
        path: "/taskDetails",
        name: "TaskDetails",
        component: () =>
          import(/* webpackChunkName: "login" */ "../views/TaskDetails.vue"),
      },
      {
        path: "/device-management",
        name: "DeviceManage",
        component: () =>
          import(
            /* webpackChunkName: "device" */ "../views/settings/DeviceManage/index.vue"
          ),
      },
      {
        path: "/scene-management",
        name: "SceneManage",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "../views/settings/SceneManage.vue"
          ),
      },
      {
        path: "/account-management",
        name: "AccountManage",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "../views/settings/AccountManage.vue"
          ),
      },
      {
        path: "/pipeline-management",
        name: "PipelineManage",
        component: () =>
          import(
            /* webpackChunkName: "pipeline" */ "../views/settings/PipelineManage.vue"
          ),
      },
      {
        path: "/authority-management",
        name: "AuthorityManagement",
        component: () =>
          import(
            /* webpackChunkName: "AuthorityManagement" */ "../views/settings/AuthorityManagement.vue"
          ),
      },
      {
        path: "/In-office-script",
        name: "Script",
        component: () =>
          import(
            /* webpackChunkName: "Script" */ "../views/automation_script/Script.vue"
          ),
      },
      {
        path: "/performance_analysis",
        name: "PerformanceAnalysis",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/PerformanceAnalysis.vue"
          ),
      },
      {
        path: "/custom_report",
        name: "CustomReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/CustomReport.vue"
          ),
      },
      {
        path: "/mono_dump",
        name: "MonoDump",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/MonoDump.vue"
          ),
      },
      {
        path: "/x_hook",
        name: "xHook",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/Xhook.vue"
          ),
      },
      {
        path: "/wedo",
        name: "Wedo",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/Wedo.vue"
          ),
      },
      {
        path: "/ultimate_performance_test",
        name: "UltimatePerformanceTest",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/UltimatePerformanceTest.vue"
          ),
      },
      {
        path: "/skin_managemente",
        name: "SkinManagemente",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/SkinManagemente.vue"
          ),
      },
      {
        path: "/automated_smoke_test",
        name: "AutomatedSmokeTest",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/AutomatedSmokeTest.vue"
          ),
      },
      {
        path: "/login_traversal_report",
        name: "LoginTraversalReport",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/LoginTraversalReport.vue"
          ),
      },
      {
        path: "/report_list",
        name: "ReportList",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/ReportList.vue"
          ),
      },
      {
        path: "/report_setting",
        name: "ReportSetting",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/settings/ReportSetting.vue"
          ),
      },
      {
        path: "/project_setting",
        name: "ProjectSetting",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/settings/ProjectSetting.vue"
          ),
      },
      {
        path: "/403",
        name: "403",
        component: () =>
          import(/* webpackChunkName: "403" */ "../views/403Page.vue"),
      },
      {
        path: "/500",
        name: "500",
        component: () =>
          import(/* webpackChunkName: "404" */ "../views/500Page.vue"),
      },
      {
        path: "/testdmo",
        name: "Testdmo",
        component: () =>
          import(/* webpackChunkName: "404" */ "../views/Testdmo.vue"),
      },
      {
        path: "/resource_statistics",
        name: "ResourceStatistics",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/ResourceStatistics.vue"
          ),
      },
      {
        path: "/adb",
        name: "ADB",
        component: () =>
          import(/* webpackChunkName: "404" */ "../views/performance/ADB.vue"),
      },
      {
        path: "/token_library",
        name: "TokenLibrary",
        component: () =>
          import(/* webpackChunkName: "403" */ "../views/TokenLibrary.vue"),
      },
      {
        path: "/ai_test_report",
        name: "AiTestReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/AiTestReport.vue"
          ),
      },
      {
        path: "/generate_table_data",
        name: "GenerateTableData",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/GenerateTableData.vue"
          ),
      },
      {
        path: "/protocol_test_report",
        name: "ProtocolTestReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/ProtocolTestReport.vue"
          ),
      },
      {
        path: "/copy-foreach-auto",
        name: "copy-foreach-auto",
        component: () => import("../views/performance/copy-foreach-auto.vue"),
      },

      {
        path: "/auto_test_report",
        name: "AutoTestReport",
        component: () => import("../views/performance/AutoTestReport.vue"),
      },

      {
        path: "/live_test_report",
        name: "LiveTestReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/LiveTestReport.vue"
          ),
      },
      {
        path: "/live_test_report_new",
        name: "LiveTestReportNew",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/LiveTestReportNew.vue"
          ),
      },
      {
        path: "/simple_perf_live",
        name: "SimplePerfLive",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SimplePerfLive.vue"
          ),
      },
      {
        path: "/simple_perf_skin",
        name: "SimplePerfSkin",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SimplePerfSkin.vue"
          ),
      },
      {
        path: "/simple_perf_data",
        name: "SimplePerfData",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SimplePerfData.vue"
          ),
      },
      {
        path: "/light_perf",
        name: "LightPerf",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/LightPerf.vue"
          ),
      },
      {
        path: "/android_app_file",
        name: "AndroidAppFile",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/AndroidAppFile.vue"
          ),
      },
      {
        path: "/android_line_process_performance_detection",
        name: "AndroidLineProcessPerformanceDetection",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/AndroidLineProcessPerformanceDetection.vue"
          ),
      },
      {
        path: "/smoke_record",
        name: "SmokeRecord",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SmokeRecord/index.vue"
          ),
      },
      {
        path: "/inclusion_resources",
        name: "InclusionResources",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/InclusionResources.vue"
          ),
      },
      {
        path: "/inclusion_resources_test_report",
        name: "InclusionResourcesTestReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/InclusionResourcesTestReport.vue"
          ),
      },
      {
        path: "/abnormal_lighting_test_report",
        name: "AbnormalLighting",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/AbnormalLighting.vue"
          ),
      },
      {
        path: "/simple_perf2",
        name: "SimplePerf2",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SimplePerf2.vue"
          ),
      },
      {
        path: "/memory_data",
        name: "MemoryData",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/MemoryData.vue"
          ),
      },
      {
        path: "/memory_report",
        name: "MemoryReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/MemoryReport.vue"
          ),
      },

      {
        path: "/memory_report_new",
        name: "MemoryReportNew",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/MemoryReportNew.vue"
          ),
      },
      {
        path: "/svn_log",
        name: "SvnLog",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SvnLog.vue"
          ),
      },
      {
        path: "/ds_log",
        name: "DsLog",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/DsLog.vue"
          ),
      },
      {
        path: "/skin_maintenance",
        name: "SkinMaintenance",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/SkinMaintenance.vue"
          ),
      },

      {
        path: "/memory-resource-overview",
        name: "memory-resource-overview",
        component: () =>
          import("../views/performance/memory-resource-overview/index.vue"),
      },

      {
        path: "/memory-resource-links",
        name: "memory-resource-links",
        component: () =>
          import("../views/performance/memory-resource-links.vue"),
      },

      {
        path: "/memory_resource_monitoring",
        name: "MemoryResourceMonitoring",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/memory-resource-monitoring.vue"
          ),
      },
      {
        path: "/history_memory_resource_monitoring",
        name: "HistoryMemoryResourceMonitoring",
        component: () =>
          import("../views/performance/history-memory-resource-monitoring.vue"),
        //import("../views/performance/HistoryMemoryResourceMonitoring.vue")
      },
      {
        path: "/resource_scanning",
        name: "ResourceScanning",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/ResourceScanning.vue"
          ),
      },
      {
        path: "/ui_and_level_test_report",
        name: "UiAndLevelsTestReport",
        component: () =>
          import(
            /* webpackChunkName: "404" */ "../views/performance/UiAndLevelsTestReport.vue"
          ),
      },

      {
        path: "/smoke-from-light-exposure-lookdev",
        name: "smokeFromLightExposureLookdev",
        component: () =>
          import("../views/performance/smoke-from-light-exposure-lookdev.vue"),
      },

      {
        path: "/resource_scan_overview",
        name: "ResourceScanOverview",
        component: () =>
          import("../views/performance/resource_scan/overview/index.vue"),
      },

      {
        path: "/resource_scan_old_sub_car",
        name: "ResourceScanOldSubCar",
        component: () =>
          import(
            /* webpackChunkName: "performance chart" */ "../views/performance/resource_scan/sub_car/index.vue"
          ),
      },

      {
        path: "/resource_scan_primary_base",
        name: "ResourceScanPrimaryBase",
        component: () =>
          import("../views/performance/resource_scan/primary/base/index.vue"),
      },

      {
        path: "/resource_scan_primary_car",
        name: "ResourceScanPrimaryCar",
        component: () =>
          import("../views/performance/resource_scan/primary/car/index.vue"),
      },

      {
        path: "/resource_scan_primary_scene",
        name: "ResourceScanPrimaryScene",
        component: () =>
          import("../views/performance/resource_scan/primary/scene/index.vue"),
      },

      {
        path: "/resource_scan_primary_role",
        name: "ResourceScanPrimaryRole",
        component: () =>
          import("../views/performance/resource_scan/primary/role/index.vue"),
      },

      {
        path: "/resource_scan_primary_pet_ride",
        name: "ResourceScanPrimaryPetRide",
        component: () =>
          import("../views/performance/resource_scan/primary/pet-ride.vue"),
      },

      {
        path: "/resource_scan_primary_pet",
        name: "ResourceScanPrimaryPet",
        component: () =>
          import("../views/performance/resource_scan/primary/pet.vue"),
      },

      {
        path: "/resource_scan_primary_throne",
        name: "ResourceScanPrimaryThrone",
        component: () =>
          import("../views/performance/resource_scan/primary/throne.vue"),
      },

      {
        path: "/resource-scan-primary-effect",
        name: "ResourceScanPrimaryEffect",
        component: () =>
          import("../views/performance/resource_scan/primary/effect/index.vue"),
      },

      {
        path: "/resource-scan-primary-cg",
        name: "ResourceScanPrimaryCg",
        component: () =>
          import("../views/performance/resource_scan/primary/cg/index.vue"),
      },

      {
        path: "/resource_scan_sub_car",
        name: "ResourceScanSubCar",
        component: () =>
          import("../views/performance/resource_scan/sub/car.vue"),
      },

      {
        path: "/resource_scan_sub_scene",
        name: "ResourceScanSubScene",
        component: () =>
          import("../views/performance/resource_scan/sub/scene/index.vue"),
      },

      {
        path: "/resource_scan_sub_role",
        name: "ResourceScanSubRole",
        component: () =>
          import("../views/performance/resource_scan/sub/role/index.vue"),
      },

      {
        path: "/resource_scan_sub_pet_ride",
        name: "ResourceScanSubPetRide",
        component: () =>
          import("../views/performance/resource_scan/sub/pet-ride.vue"),
      },

      {
        path: "/resource_scan_sub_pet",
        name: "ResourceScanSubPet",
        component: () =>
          import("../views/performance/resource_scan/sub/pet.vue"),
      },

      {
        path: "/resource_scan_sub_throne",
        name: "ResourceScanSubThrone",
        component: () =>
          import("../views/performance/resource_scan/sub/throne.vue"),
      },

      {
        path: "/resource_scan_sub_base",
        name: "ResourceScanSubBase",
        component: () =>
          import("../views/performance/resource_scan/sub/base/index.vue"),
      },

      {
        path: "/resource-scan-sub-effect",
        name: "resource-scan-sub-effect",
        component: () =>
          import("../views/performance/resource_scan/sub/effect/index.vue"),
      },

      {
        path: "/resource-scan-sub-cg",
        name: "resource-scan-sub-cg",
        component: () =>
          import("../views/performance/resource_scan/sub/cg/index.vue"),
      },

      {
        path: "/resource-scan-three-scene-hot",
        name: "resource-scan-three-scene-hot",
        component: () =>
          import(
            "../views/performance/resource_scan/three/scene-hot/index.vue"
          ),
      },

      {
        path: "week-data",
        name: "performance-week-data",
        component: () => import("../views/performance/week-data/index.vue"),
      },

      {
        path: "/skill-auto-test",
        name: "skill-auto-test",
        component: () => import("../views/performance/skill-auto-test.vue"),
      },

      {
        path: "/stability-test",
        name: "stability-test",
        component: () =>
          import("../views/performance/stability-test/index.vue"),
      },

      {
        path: "/cutsence-test-report",
        name: "cutsence-test-report",
        component: () =>
          import("../views/performance/cutsence-test-report.vue"),
      },
    ], //二级子路由
  },
  {
    path: "/perf_data",
    name: "PerfData",
    component: () =>
      import(
        /* webpackChunkName: "performance chart" */ "../views/performance/PerfData.vue"
      ),
  },
  {
    path: "/batch_generate_skins",
    name: "BatchGenerateSkins",
    component: () =>
      import(
        /* webpackChunkName: "performance chart" */ "../views/hok/BatchGenerateSkins.vue"
      ),
  },

  {
    path: "/object_memory",
    name: "ObjectMemory",
    component: () =>
      import(
        /* webpackChunkName: "404" */ "../views/performance/ObjectMemory.vue"
      ),
  },
  {
    path: "/full_screen_display",
    name: "FullScreenDisplay",
    component: () =>
      import(
        /* webpackChunkName: "404" */ "../views/performance/FullScreenDisplay.vue"
      ),
  },
  {
    path: "/auto_test",
    name: "AutoTest",
    component: () =>
      import(
        /* webpackChunkName: "performance chart" */ "../views/performance/AutoTest.vue"
      ),
  },

  {
    path: "/dmo",
    name: "Dmo",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/performance/Dmo.vue"),
  },
  {
    path: "/dmo_perfetto",
    name: "DmoPerfetto",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/performance/DmoPerfetto.vue"
      ),
  },
  {
    path: "/dmo_perfetto_unreleased",
    name: "DmoPerfettoUnreleased",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/performance/DmoPerfettoUnreleased.vue"
      ),
  },
  {
    path: "/test",
    name: "Test",
    component: () => import(/* webpackChunkName: "task" */ "../views/Test.vue"),
  },
  {
    path: "/test1",
    name: "Test1",
    component: () =>
      import(/* webpackChunkName: "task" */ "../views/Test1.vue"),
  },
  {
    path: "/login_new",
    name: "LoginNew",
    component: () => import("../views/LoginNew.vue"),
  },
  {
    path: "/log",
    name: "Log",
    component: () => import(/* webpackChunkName: "login" */ "../views/Log.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/workbench",
    name: "WorkBench",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/WorkBench.vue"),
  },

  {
    path: "/operational-data",
    name: "OperationalData",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/OperationalData.vue"),
  },
  {
    path: "/TopData",
    name: "TopData",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/TopData.vue"),
  },
  {
    path: "/top_search",
    name: "TopSearch",
    component: () =>
      import(
        /* webpackChunkName: "403" */ "../views/performance/TopSearch.vue"
      ),
  },
  {
    path: "/test_appointment",
    name: "TestAppointment",
    component: () => import("../views/TestAppointment/index.vue"),
  },

  {
    path: "/TopSubData",
    name: "TopSubData",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/TopSubData.vue"),
  },

  {
    path: "/platform-monitoring",
    name: "PlatformMonitoring",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/PlatformMonitoring.vue"),
  },
  {
    path: "/project-hall",
    name: "ProjectHall",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/ProjectHall.vue"),
  },
  {
    path: "/custom01",
    name: "Custom01",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/Custom01.vue"),
  },

  {
    path: "/games_new",
    name: "GamesNew",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/GamesNew.vue"),
  },
  {
    path: "/client-report",
    name: "client-report",
    component: () => import("../views/performance/client-report/index.vue"),
  },
  {
    path: "/client-report/create",
    name: "create-client-report",
    component: () => import("../views/performance/client-report/index.vue"),
  },
  {
    path: "/client-report/edit",
    name: "edit-client-report",
    component: () => import("../views/performance/client-report/index.vue"),
  },

  {
    path: "/hok",
    name: "Hok",
    component: () =>
      import(
        /* webpackChunkName: "403" */ "../views/performance/hok/index.vue"
      ),
  },
  {
    path: "/aov",
    name: "aov",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/performance/aov.vue"),
  },
  {
    path: "/hok_domestic",
    name: "HokDomestic",
    component: () =>
      import(
        /* webpackChunkName: "403" */ "../views/performance/HokDomestic/index.vue"
      ),
  },
  {
    path: "/awakening-skin",
    name: "awakening-skin",
    component: () => import("../views/performance/awakening-skin.vue"),
  },
  {
    path: "/devices",
    name: "EquipmentManagement",
    component: () =>
      import(
        /* webpackChunkName: "403" */ "../views/performance/EquipmentManagement.vue"
      ),
  },
  {
    path: "/sgame",
    name: "Sgame",
    component: () =>
      import(/* webpackChunkName: "403" */ "../views/performance/Sgame.vue"),
  },

  {
    path: "/nav/runmax/client-perf-test-report2",
    name: "RunmaxPerfTestReport2",
    component: () =>
      import(
        /* webpackChunkName: "RunmaxPerfTestReport" */ "../views/RunmaxPerfTestReport/index.vue"
      ),
  },

  {
    path: "/nav/runmax/client-perf-test-report",
    name: "RunmaxPerfTestReport",
    component: () =>
      import(
        /* webpackChunkName: "RunmaxPerfTestReport" */ "../views/RunmaxPerfTestReport2/index.vue"
      ),
  },

  {
    path: "/nav/runmax/client-perf-test-pc-report",
    name: "RunmaxPerfTestPcReport",
    component: () =>
      import(
        /* webpackChunkName: "RunmaxPerfTestReport" */ "../views/RunmaxPerfTestPcReport.vue"
      ),
  },

  {
    path: "/compare-client-perf",
    name: "compare-client-perf",
    component: () => import("../views/index/compare-client-perf/index.vue"),
  },

  {
    path: "/device-manage",
    name: "device-manage",
    component: () => import("../views/index/device-manage/index.vue"),
  },

  {
    path: "/test",
    name: "test",
    component: () => import("../views/Test.vue"),
  },

  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404Page.vue"),
  },
  {
    path: "/player",
    name: "Player",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/performance/Player.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 添加请求拦截器
axios.interceptors.request.use(
  function (config: any) {
    // 在发送请求之前做些什么
    config.headers.url = router.currentRoute.value.fullPath;
    config.headers["Access-Token"] = localStorage.getItem("token");

    let loading = {
      fullscreen: true,
      background: "rgba(255, 255, 255, 0.1)",
    };
    if (config.loading !== undefined) loading = config.loading;
    if (loading) {
      config.loading = ElLoading.service(loading);
    }

    // console.log(router.currentRoute)
    // console.log(router.currentRoute)
    // console.log(router.currentRoute.value)
    //如果query中有中文，会导致报错
    //config.headers.query = JSON.stringify(router.currentRoute.value.query);

    // console.log(config.headers)
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

function handleJump() {
  if (location.host.includes("qq")) {
    if (!location.pathname.startsWith("/login_new"))
      router.push({ name: "LoginNew" });
  } else {
    if (!location.pathname.startsWith("/login")) router.push({ name: "Login" });
  }
}

// 添加响应拦截器
axios.interceptors.response.use(
  function (response: any) {
    // 对响应数据做点什么
    // console.log(response, 'response')
    // console.log(router.currentRoute.value.fullPath)
    if (response.config.loading) {
      response.config.loading.close();
    }

    return response;
  },

  async function (error) {
    if (!error) return {};
    // 对响应错误做点什么
    // console.log(error.response,'error')
    if (error?.config?.loading) {
      error.config.loading.close();
    }

    if (
      error.response.status === 403 &&
      error.response.data == "Access Forbidden"
    ) {
      router.push({ path: "/404" });
      return;
    }
    if (
      error.response.status === 403 &&
      router.currentRoute.value.name !== "ProjectHall"
    ) {
      if (
        error.response.data.detail !== "用户认证失败" &&
        error.response.config.url !== "/user/my_last_project/" &&
        error.response.data.detail !== "未获取到token" &&
        error.response.data !== "没有权限访问，请联系管理员" &&
        error.response.data.detail !== "Token not found"
      ) {
        // router.push({path: '/403'})
        let Project = Number(getLocalProject())
          ? Number(getLocalProject())
          : Number(router.currentRoute.value.query.project);
        let admin: any = [];
        await dispatchGetProjectUsers(store, Project);
        readProjectUsers(store).forEach((item: any) => {
          if (item.is_project_admin) {
            admin.push(item.user);
          }
        });
        if (admin.length !== 0) {
          if (document.getElementsByClassName("is-message-box").length === 0) {
            let admin0 = admin[0] ? admin[0] + "," : "";
            let admin1 = admin[1] ? admin[1] + "," : "";
            let admin2 = admin[2] ? admin[2] : "";
            ElMessageBox.alert(
              '<p style="color: #c41e3d">暂无该项目操作权限,请联系该项目管理员<span style="color: #409eff">' +
                admin0 +
                admin1 +
                admin2 +
                "</span></p>",
              "操作提示",
              {
                dangerouslyUseHTMLString: true,
                showClose: false,
                customClass: "mesBox",
              },
            ).then(() => {
              router.push({ path: "/" });
            });
          }
          document
            .getElementsByClassName("is-message-box")[0]
            .setAttribute("style", "background-color:rgba(0,0,0,.7)");
        } else {
          // 未登录的情况下先直接登陆，后台尝试从网关获取身份
          await dispatchLogIn(store, {
            username: "",
            password: "",
            tapd_token: "",
            login_type: "web",
          });
        }
      }

      if (error.response.data.detail == "Token not found") {
        //未登录的情况下先直接登陆，后台尝试从网关获取身份
        await dispatchLogIn(store, {
          username: "",
          password: "",
          tapd_token: "",
          login_type: "web",
        });
        if (!readIsLoggedIn(store)) {
          //没有token
          handleJump();
        }
      }
    } else if (
      error.response.status === 404 &&
      !router.currentRoute.value.query.screenshot
    ) {
      // router.push({path: '/404'})
    } else if (error.response.status === 401) {
      handleJump();
    } else if (error.response.status === 409) {
      if (
        error.response.data ===
        "The user does not have permission for all projects."
      ) {
        // ElMessage({
        //   showClose: true,
        //   // message: "请求异常，请联系管理员",
        //   message: error.response.data,
        //   type: 'warning'
        // });
        // console.log(error.response.data)
      } else {
        if (typeof error.response.data === "object") {
          //ElMessage.error(error.response.data.data);
        } else {
          ElMessage.error(error.response.data);
        }
      }
    } else if (error.response.status === 400) {
      // alert(error.response.data)
      ElMessage({
        showClose: true,
        // message: "请求异常，请联系管理员",
        message: error.response.data,
        type: "error",
      });
    } else {
      // router.push({ path: '/500' })
      ElMessage.error("数据不存在或已被删除");
    }

    //return error.response
    return Promise.reject(error.response);
  },
);

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach(async (to, from, next) => {
  if (
    to.path != "/" &&
    to.path != "/403" &&
    to.path != "/404" &&
    to.path != "/login" &&
    to.path != "/login_new" &&
    to.path != "/project-hall"
  ) {
    //保存当前路由
    saveLocalStoragePreRoute(to.fullPath);
  }

  if (to.path == "/project-hall" && to.query.code) {
    await dispatchWechatLogIn(store, { code: to.query.code as string });
  }
  // 进入的是404、403、log、Login页面无需跳转，否则可能会造成页面无限刷新
  if (
    ["404", "403", "500", "Home", "LoginNew", "Log", "Login"].includes(
      to.name as string,
    )
  ) {
    next();
  }
  // 如果没有从页面存储获取到项目,
  if (
    (!getLocalProject() || getLocalProject() === "null") &&
    !to.query.screenshot
  ) {
    await dispatchGetMyLastProject(store);
    // saveLocalProject(String(readMyLastProject(store)))
  }

  const localProject: any = getLocalProject();
  //commitSetMyLastProject(store, parseInt(localProject));
  await dispatchCheckLoggedIn(store);

  if (readIsLoggedIn(store) === true) {
    if (to.name) {
      await dispatchGetStaffInfo(store);
      const staff_info = readStaffInfo(store);

      dispatchAddVisitStat(store, {
        module: to.name,
        dept: staff_info.DeptNameString,
      });
    }

    // 为每个路由加上项目id
    if (to.query.project) {
      // 如果已经加上了, 则判断是不是从外部打开的链接, 从外部打开的链接from.query.project为undifined, 从外部打开的更新一下最后访问的项目、及本地浏览器缓存的项目
      if (!from.query.project && !to.query.screenshot) {
        const project = Number(to.query.project);
        // 更新项目
        await dispatchUpdateMyLastProject(store, {
          last_visit_project: project,
        });
        await saveLocalProject(String(project));
        await saveLocalStorageProject(String(project));
      }
      next();
    } else if (
      to.path !== "/" &&
      to.path != "/project-hall" &&
      to.path != "/custom01" &&
      to.path != "/games_new" &&
      to.path != "/hok_domestic" &&
      to.path != "/hok" &&
      to.path != "/sgame" &&
      to.path != "/object_memory" &&
      to.path != "/devices" &&
      to.path != "/batch_generate_skins" &&
      to.name != "TestAppointment" &&
      to.name != "client-report"
    ) {
      // 如果没有加上, 则用户跳转的时候加上本地缓存的项目
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.project = getLocalProject();
      next({
        path: to.path,
        query: toQuery,
      });
    } else {
      next();
    }
  } else if (
    (to.path === "/test_report" ||
      to.path === "/custom_report" ||
      to.path === "/test_report_aov" ||
      to.path === "/test_report_aov2" ||
      to.path === "/test_report_speedmobile") &&
    to.query.screenshot
  ) {
    next();
  } else {
    // 未登录的情况下先直接登陆，后台尝试从网关获取身份
    if (to.path === "/test_appointment" && to.query.wereport_token) {
      await dispatchWereportLogIn(store, {
        wereport_token: to.query.wereport_token as any,
      });
      next();
    } else {
      await dispatchLogIn(store, {
        username: "",
        password: "",
        tapd_token: "",
        login_type: "web",
      });
    }

    if (readIsLoggedIn(store) === false) {
      // 未获取到身份
      // 如果是开发环境则需要手动登录
      if (envTag === "development") {
        if (to.path === "/login") {
          next();
        } else {
          next("/login");
        }
        // 研发环境使用login页面的账号密码登录（实际上后台并不验证密码，只验证账号存在即可）
        // next('/login');
      } else if (envTag === "production") {
        // 如果是发布环境，未登录情况下跳转TAPD登陆
        if (to.path === "/login_new") {
          // 如果目标为login页面，则直接跳转到login去执行平台登陆
          next();
        } else if (to.path === "/login") {
          next();
        } else {
          next({ name: "LoginNew" });
          // window.location.replace("http://tapd.tencent.com/ptlogin/ptlogins/login?ref=https://gamerobot.qq.com/login&site=GameRobot")
        }
      } else {
        //router.push("/404");
      }
    } else {
      next();
    }
  }

  //如果访问未注册路由，跳转404页面
  if (!to.name) {
    router.push("/404");
  }

  // 项目管理员才可访问 PipelineManage
  // if (to.name === "PipelineManage") {
  //   const current_project = readMyProjects(store).filter(item=>item.project.id===Number(getLocalProject()))[0]
  //   if (!current_project.is_project_admin or 超级管理员) {
  //     router.push('/403')
  //   }
  // }
});

export default router;
